import { render, staticRenderFns } from "./WizardCompanyStep.vue?vue&type=template&id=ccac6942&scoped=true&"
import script from "./WizardCompanyStep.vue?vue&type=script&lang=js&"
export * from "./WizardCompanyStep.vue?vue&type=script&lang=js&"
import style0 from "./WizardCompanyStep.vue?vue&type=style&index=0&id=ccac6942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccac6942",
  null
  
)

export default component.exports